"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateScroll = void 0;
const utils_1 = require("./");
const updateScroll = (ivars, scrollView) => {
    (0, utils_1.scroll)(ivars.position, ivars, scrollView);
};
exports.updateScroll = updateScroll;
